/** Created by azhou on 2019/3/8.*/
<template>
  <div>
    <!-- <left-text-border class="mb-3"
                      leftText="联系人"
                      v-model="BasicInfo.contact"/>
    <left-text-border class="mb-3"
                      leftText="联系人电话"
                      v-model="BasicInfo.mob"/> -->
    <left-text-border class="mb-3"
                      leftText="企业传真"
                      v-model="BasicInfo.travel_fax"/>
    <left-text-border class="mb-3"
                      leftText="企业总机"
                      v-model="BasicInfo.travel_tel"/>
    <!-- <left-text-border class="mb-3"
                      leftText="官网地址"
                      v-model="BasicInfo.homepage"/> -->
    <!-- <left-text-border class="mb-3"
                      leftText="业务范围"
                      v-model="BasicInfo.business"/>
    <left-text-border class="mb-3"
                      leftText="擅长业务"
                      type="textarea"
                      v-model="BasicInfo.profession"/> -->
    <div class="d-start-start mb-4">
      <left-text leftText="简介"/>
      <rich-editor class="w-100" v-model="BasicInfo.intro" :contentProps="BasicInfo.intro" :allowUploadImg=false />
    </div>
    <!-- <left-text-border class="mb-3"
                      leftText="简介"
                      type="textarea"
                      v-model="BasicInfo.intro"/> -->
    <div class="d-start-start">
      <left-text leftText="门店LOGO"/>
      <upload-image @fileChange="(imgs)=>{this.avatar = imgs[0];}" :existImgs="BasicInfo.avatar" :maxLength="1" editMode/>
    </div>
    <div class="d-start-start mt-4">
      <left-text leftText="电子章"/>
      <upload-image @fileChange="(imgs)=>{this.seal = imgs[0];}" :existImgs="BasicInfo.seal" :maxLength="1" editMode/>
    </div>
    <el-button @click="submitForm" class="mt-4 w-25 btn-login">保存信息</el-button>
  </div>

</template>

<script>
  import { mapState,mapGetters } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import RichEditor from '../../../../components/Editor/RichEditor.vue'

  export default {
    name: 'TStoreBasic',
    components: { RichEditor },
    computed: {
      ...mapState(['StoreBasicInfo',]),
      ...mapGetters(['isGroup','storeInfo']),
    },
    data () {
      return {
        BasicInfo: {},
        avatar:'',
        seal: ''
      }
    },
    watch: {
      StoreBasicInfo (newVal) { this.BasicInfo = newVal; }
    },
    created () {
      this.BasicInfo = this.StoreBasicInfo;
    },
    methods: {
      /*保存门店基本信息*/
      async submitForm () {
        if (!this.$GFUN.powerIsInArray([99,234])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确定保存信息么？',async () => {
          this.BasicInfo.avatar = (await UploadImages(this.avatar))[0]
          this.BasicInfo.seal = (await UploadImages(this.seal))[0]
          this.$emit('saveInfo', this.BasicInfo);
        })
      }
    }
  }
</script>
